
import { dataStore } from "@/states/states";
export default {
  name: "MoreRight",
  data() {
    return dataStore
  },
};
